import { get } from "core-web/libs/GrebbCommerceAPI/util/authClient";
import { getModel } from "core-web/state";

export default async (basketId) => {
    const response = await get(`/frontend/basket/id/${basketId}`, {
        application_id: getModel("application").applicationId,
    });

    return await response.body();
};
